import { TagOrigin, TagStatus, TagValidationStatus } from 'app/api/tag-queries/types';
import { i18n } from 'app/utils/i18n';

import './TagBadges.scss';

export const StatusBadge = ({ status }: { status?: TagStatus }) =>
  status ? <span className={`tag-badge tag-badge--status-${status}`}>{i18n(`tag.status.${status}`)}</span> : <>-</>;

export const ValidationBadge = ({ status }: { status?: TagValidationStatus }) =>
  status ? <span className={`tag-badge tag-badge--status-${status}`}>{i18n(`tag.status.${status}`)}</span> : <>-</>;

export const OriginBadge = ({ origin }: { origin?: TagOrigin }) => (
  <span className={`tag-badge tag-badge--origin-${origin ?? 'human'}`}>{i18n(`tag.ai.origin.${origin ?? 'human'}`)}</span>
);
